export enum TUserGroupSettingsTab {
  GroupPermissions = 'group-permissions',
  DeviceAccess = 'device-access',
}
